import React from 'react';
import { Helmet } from 'react-helmet-async';

const SmsTerms = () => {
  return (
    <div style={{paddingTop: '100px'}}>
      <Helmet>
        <title>SMS Terms & Conditions - Text Message Program | RMQ Digital</title>
        <meta name="description" content="SMS program terms: message frequency, opt-out instructions (STOP), HELP keyword response, supported carriers, and CTIA compliance. Consent not required for service." />
        <meta name="keywords" content="SMS terms, text message program, STOP keyword, HELP response, CTIA compliance, A2P 10DLC, message rates" />
      </Helmet>
      
      <section style={{padding: '4rem 2rem', background: '#f9fafb'}}>
        <div style={{maxWidth: '1200px', margin: '0 auto'}}>
          <h1 style={{fontSize: '3rem', fontWeight: '800', marginBottom: '1rem', color: '#1f2937', fontFamily: 'Space Grotesk'}}>SMS Terms & Conditions</h1>
          
          <div style={{maxWidth: '800px', margin: '0 auto', lineHeight: '1.8'}}>
            <p style={{marginBottom: '2rem', fontStyle: 'italic', color: '#6b7280'}}>
              <strong>Last Updated:</strong> {new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}
            </p>

            <div style={{background: '#fef3c7', padding: '2rem', borderRadius: '12px', marginBottom: '2rem', border: '2px solid #f59e0b'}}>
              <h2 style={{color: '#92400e', marginBottom: '1rem', fontSize: '1.5rem'}}>Reseller Services Notice</h2>
              <p style={{color: '#78350f', marginBottom: '1rem'}}>
                <strong>Important:</strong> RMQ Digital operates as a service provider and reseller. Messages you receive may be sent by:
              </p>
              <ul style={{color: '#78350f', paddingLeft: '1.5rem', marginBottom: '1rem'}}>
                <li><strong>Our direct clients:</strong> Businesses using our platform to send messages to their customers</li>
                <li><strong>RMQ Digital:</strong> For our own marketing and service notifications</li>
              </ul>
              <p style={{color: '#78350f'}}>
                If you received a message from one of our clients, your consent was collected through their website, application, or form. 
                The client (Sender) is responsible for message content and compliance. To opt-out, reply STOP or contact the Sender directly.
              </p>
            </div>

            <div style={{background: '#ede9fe', padding: '2rem', borderRadius: '12px', marginBottom: '2rem', border: '2px solid #8b5cf6'}}>
              <h2 style={{color: '#6d28d9', marginBottom: '1rem', fontSize: '1.5rem'}}>SMS Program Overview</h2>
              <p style={{color: '#5b21b6'}}>
                RMQ Digital provides SMS messaging services for marketing campaigns. By opting in to receive SMS messages, 
                you agree to receive text messages regarding your marketing campaigns, service updates, and important notifications.
              </p>
            </div>

            <h2 style={{color: '#6d28d9', marginBottom: '1rem', fontSize: '1.75rem'}}>Program Description</h2>
            <p style={{marginBottom: '1rem'}}>
              Our SMS program allows us to send you:
            </p>
            <ul style={{marginBottom: '2rem', paddingLeft: '2rem'}}>
              <li>Campaign status updates and notifications</li>
              <li>Service announcements and features</li>
              <li>Account alerts and important information</li>
              <li>Marketing tips and best practices</li>
              <li>Promotional offers and updates</li>
            </ul>

            <h2 style={{color: '#6d28d9', marginBottom: '1rem', fontSize: '1.75rem'}}>Sample Messages</h2>
            <div style={{background: '#f9fafb', padding: '1.5rem', borderRadius: '12px', marginBottom: '2rem', border: '1px solid #e5e7eb'}}>
              <p style={{marginBottom: '1rem', fontWeight: '600', color: '#1f2937'}}>Examples of messages you may receive:</p>
              
              <div style={{background: 'white', padding: '1rem', borderRadius: '8px', marginBottom: '1rem', border: '1px solid #e5e7eb'}}>
                <p style={{fontSize: '0.9rem', color: '#374151', fontStyle: 'italic'}}>
                  "RMQ Digital: Your SMS campaign has been successfully launched. Track performance at rmqdigital.com. Reply STOP to opt out, HELP for support. Msg&data rates may apply."
                </p>
              </div>

              <div style={{background: 'white', padding: '1rem', borderRadius: '8px', marginBottom: '1rem', border: '1px solid #e5e7eb'}}>
                <p style={{fontSize: '0.9rem', color: '#374151', fontStyle: 'italic'}}>
                  "Campaign Update: Your email campaign reached 5,000 recipients with 25% open rate. View details in your dashboard. Reply STOP to unsubscribe."
                </p>
              </div>

              <div style={{background: 'white', padding: '1rem', borderRadius: '8px', border: '1px solid #e5e7eb'}}>
                <p style={{fontSize: '0.9rem', color: '#374151', fontStyle: 'italic'}}>
                  "RMQ Digital: New feature alert! Automated workflows now available. Login to explore. Msg&data rates may apply. Reply STOP to opt out."
                </p>
              </div>
            </div>

            <h2 style={{color: '#6d28d9', marginBottom: '1rem', fontSize: '1.75rem'}}>Message Frequency</h2>
            <p style={{marginBottom: '2rem'}}>
              Message frequency varies depending on your account activity and campaign volume. You may receive up to 10 messages per month, 
              though frequency may be higher or lower based on your service usage and preferences.
            </p>

            <h2 style={{color: '#6d28d9', marginBottom: '1rem', fontSize: '1.75rem'}}>Message & Data Rates</h2>
            <div style={{background: '#fef2f2', padding: '1.5rem', borderRadius: '12px', marginBottom: '2rem', border: '2px solid #ef4444'}}>
              <p style={{fontWeight: '600', color: '#dc2626', marginBottom: '0.5rem'}}>
                IMPORTANT: Message and Data Rates May Apply
              </p>
              <p style={{color: '#991b1b'}}>
                Standard messaging rates from your mobile carrier will apply to all SMS messages sent and received. 
                Contact your mobile carrier for details about your messaging plan. RMQ Digital is not responsible for carrier charges.
              </p>
            </div>

            <h2 style={{color: '#6d28d9', marginBottom: '1rem', fontSize: '1.75rem'}}>How to Opt-Out</h2>
            <p style={{marginBottom: '1rem'}}>
              You can opt-out of receiving SMS messages at any time:
            </p>
            <ul style={{marginBottom: '1rem', paddingLeft: '2rem'}}>
              <li><strong>Text STOP:</strong> Reply STOP, UNSUBSCRIBE, CANCEL, END, or QUIT to any message</li>
              <li><strong>Email:</strong> Send opt-out request to optout@rmqdigital.com</li>
              <li><strong>Account Settings:</strong> Manage preferences in your account dashboard</li>
            </ul>
            <p style={{marginBottom: '2rem'}}>
              After opting out, you will receive a confirmation message and will not receive further marketing messages. 
              Opt-out requests are processed immediately.
            </p>

            <h2 style={{color: '#6d28d9', marginBottom: '1rem', fontSize: '1.75rem'}}>Help & Support</h2>
            <p style={{marginBottom: '1rem'}}>
              For help with SMS messages:
            </p>
            <ul style={{marginBottom: '1rem', paddingLeft: '2rem'}}>
              <li><strong>Text HELP:</strong> Reply HELP, INFO, or SUPPORT to any message</li>
              <li><strong>Email Support:</strong> support@rmqdigital.com</li>
              <li><strong>Visit:</strong> rmqdigital.com/support</li>
            </ul>

            <div style={{background: '#ede9fe', padding: '1.5rem', borderRadius: '12px', marginBottom: '2rem', border: '2px solid #8b5cf6'}}>
              <h3 style={{color: '#6d28d9', marginBottom: '1rem', fontSize: '1.125rem'}}>HELP Keyword Auto-Response</h3>
              <p style={{color: '#5b21b6', marginBottom: '0.5rem', fontWeight: '600'}}>When you reply HELP, you will receive:</p>
              <p style={{color: '#5b21b6', fontStyle: 'italic', fontSize: '0.95rem', padding: '1rem', background: 'rgba(255,255,255,0.5)', borderRadius: '8px'}}>
                "RMQ Digital: For support, visit rmqdigital.com/support or email support@rmqdigital.com. 
                Msg&data rates may apply. Reply STOP to opt out."
              </p>
            </div>

            <h2 style={{color: '#6d28d9', marginBottom: '1rem', fontSize: '1.75rem'}}>Supported Carriers</h2>
            <p style={{marginBottom: '1rem'}}>
              Our SMS program is supported by all major U.S. carriers including:
            </p>
            <div style={{display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '1rem', marginBottom: '1rem'}}>
              <ul style={{paddingLeft: '1.5rem', margin: 0}}>
                <li>AT&T</li>
                <li>T-Mobile</li>
                <li>Verizon Wireless</li>
                <li>Sprint</li>
              </ul>
              <ul style={{paddingLeft: '1.5rem', margin: 0}}>
                <li>Boost Mobile</li>
                <li>Cricket Wireless</li>
                <li>MetroPCS</li>
                <li>U.S. Cellular</li>
              </ul>
              <ul style={{paddingLeft: '1.5rem', margin: 0}}>
                <li>Virgin Mobile</li>
                <li>Xfinity Mobile</li>
                <li>Google Fi</li>
                <li>Other major carriers</li>
              </ul>
            </div>
            <p style={{marginBottom: '2rem', fontSize: '0.9rem', color: '#6b7280'}}>
              Carriers are not liable for delayed or undelivered messages. Message delivery may be affected by 
              network conditions, device compatibility, or carrier-specific filtering.
            </p>

            <h2 style={{color: '#6d28d9', marginBottom: '1rem', fontSize: '1.75rem'}}>Consent Requirements</h2>
            <div style={{background: '#ede9fe', padding: '1.5rem', borderRadius: '12px', marginBottom: '2rem', border: '2px solid #8b5cf6'}}>
              <p style={{fontWeight: '600', color: '#6d28d9', marginBottom: '0.5rem'}}>
                Express Written Consent:
              </p>
              <p style={{color: '#5b21b6', marginBottom: '1rem'}}>
                By opting in, you provide express written consent to receive automated marketing and transactional 
                text messages from RMQ Digital.
              </p>
              <p style={{fontWeight: '600', color: '#6d28d9', marginBottom: '0.5rem'}}>
                CTIA Required Disclosure:
              </p>
              <p style={{color: '#5b21b6', marginBottom: '0.5rem'}}>
                <strong>Your consent to receive SMS is not required as a condition of purchasing any goods or services.</strong>
              </p>
              <p style={{color: '#5b21b6'}}>
                SMS consent is not transferable and will not be sold, shared, or rented to third parties for their own marketing purposes.
              </p>
            </div>

            <h2 style={{color: '#6d28d9', marginBottom: '1rem', fontSize: '1.75rem'}}>Contact Information</h2>
            <div style={{background: '#f9fafb', padding: '2rem', borderRadius: '12px', border: '1px solid #e5e7eb'}}>
              <p style={{fontWeight: '600', marginBottom: '1rem'}}>RMQ HOLDINGS INC</p>
              <p><strong>DBA:</strong> RMQ Digital</p>
              <p>2022 EAST 9TH STREET<br />BROOKLYN, NY 11223<br />United States</p>
              <p><strong>Owner:</strong> MOSHE QUBRUSI</p>
              <p><strong>EIN:</strong> 99-1828959</p>
              <p style={{marginTop: '1rem'}}><strong>Email:</strong> support@rmqdigital.com</p>
              <p><strong>Opt-Out:</strong> optout@rmqdigital.com</p>
              <p><strong>Website:</strong> rmqdigital.com</p>
            </div>

            <div style={{background: '#fef9e7', padding: '1.5rem', borderRadius: '12px', marginTop: '2rem', border: '2px solid #f59e0b'}}>
              <h3 style={{color: '#92400e', marginBottom: '1rem', fontSize: '1.125rem'}}>Quick Reference</h3>
              <p style={{color: '#92400e', marginBottom: '0.5rem'}}><strong>To Opt-Out:</strong> Text STOP to any message</p>
              <p style={{color: '#92400e', marginBottom: '0.5rem'}}><strong>For Help:</strong> Text HELP to any message</p>
              <p style={{color: '#92400e', marginBottom: '0.5rem'}}><strong>Support Email:</strong> support@rmqdigital.com</p>
              <p style={{color: '#92400e'}}><strong>Message Frequency:</strong> Varies (up to 10/month typically)</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default SmsTerms;
